import type {
  StockChangeDirection,
  StockRow,
  StockShelfChange,
  StockVariant
} from '@/domains/command-center/handlers/stock/stockMode.types'

/** The shelf before and after a row: a change on offer, one on its way, or one just made. Null for any other row. */
const shelfChangeOf = (row: StockRow): StockShelfChange | null => {
  if (row.kind === 'outcome' || row.kind === 'saving') {
    return { before: row.current, after: row.outcome.after, mode: row.mode }
  }

  if (row.kind === 'saved') return { before: row.saved.before, after: row.saved.after, mode: row.saved.mode }

  return null
}

/** The variant whose shelf a row shows, so its figure can read in that variant's unit. Null for any other row. */
const shelfVariantOf = (row: StockRow): StockVariant | null => {
  if (row.kind === 'variant' || row.kind === 'outcome' || row.kind === 'saving') return row.variant
  if (row.kind === 'saved') return row.saved.variant

  return null
}

/** Which way a change moves the shelf. A Set lands where it lands, so it has no direction even when it raises it. */
const changeDirection = ({ before, after, mode }: StockShelfChange): StockChangeDirection => {
  if (mode === 'set') return 'flat'

  return after > before ? 'up' : 'down'
}

export { changeDirection, shelfChangeOf, shelfVariantOf }
